
<template>
    <!-- Branches.vue -->
    <div>
        <HeaderBg :title="$t('adminKeyPerformanceIndicators.title')" />
        <header class="admin_content_header">
            <h2></h2>
            <div class="search">
                <input type="text" :placeholder="$t('adminKeyPerformanceIndicators.searchPlaceholder')">
            </div>
            <router-link to=""> {{$t('adminKeyPerformanceIndicators.add')}} </router-link>
            
        </header>
        <div class="filter">
            <select>
                <option value="" selected disabled>{{$t('adminKeyPerformanceIndicators.cityFilter')}}</option>
            </select>
        </div>

        <div class="main_table">
            <table width="100%">
                <thead>
                    <tr>
                        <th>{{$t('adminKeyPerformanceIndicators.branchNumber')}}</th>
                        <th>{{$t('adminKeyPerformanceIndicators.branchName')}}</th>
                        <th>{{$t('adminKeyPerformanceIndicators.phone')}}</th>
                        <th>{{$t('adminKeyPerformanceIndicators.city')}}</th>
                        <th> </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>#5036</td>
                        <td>صيدلية المجتمع الرائدة 1</td>
                        <td>0599132523</td>
                        <td>جدة</td>
                        <td>
                            <div class="options_container">
                                <img src="../../../assets/images/selectIcon.png" alt="">
                                <div class="hidden_options">
                                    <button> <img src="../../../assets/images/edit-text.png" alt=""> {{$t('adminKeyPerformanceIndicators.edit')}}  </button>
                                    <button> <img src="../../../assets/images/delete-text.png" alt=""> {{$t('adminKeyPerformanceIndicators.delete')}} </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>#5036</td>
                        <td>صيدلية المجتمع الرائدة 1</td>
                        <td>0599132523</td>
                        <td>جدة</td>
                        <td>
                            <div class="options_container">
                                <img src="../../../assets/images/selectIcon.png" alt="">
                                <div class="hidden_options">
                                    <button> <img src="../../../assets/images/edit-text.png" alt=""> {{$t('adminKeyPerformanceIndicators.edit')}}  </button>
                                    <button> <img src="../../../assets/images/delete-text.png" alt=""> {{$t('adminKeyPerformanceIndicators.delete')}} </button>
                                </div>
                            </div>
                        </td>
                    </tr>
               
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import HeaderBg from '../../global/HeaderBg/HeaderBg'
export default {
    name:'KeyPerformanceIndicators',
    components: {HeaderBg},
}
</script>
<style lang="scss" scoped>
.filter{
    select{
        background-color: #FFF;
        border: 0;
        width: 89px;
        text-align: center;
        font-size: 20px;
        border-radius: 10px;
        margin-bottom: 20px;
    }
}

</style>